// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setQuickMessagesManagementList,
  setQuickMessagesManagementEditItem,
  resetQuickMessagesManagement
} from 'src/store/modules/admin/quickMessagesManagement'

const initialState = {
  quickMessagesManagementList: [],
  quickMessagesManagementEditItem: {}
}

export default handleActions(
  {
    [setQuickMessagesManagementList](
      state,
      { payload: quickMessagesManagementList }
    ) {
      return {
        ...state,
        quickMessagesManagementList
      }
    },

    [setQuickMessagesManagementEditItem](
      state,
      { payload: quickMessagesManagementEditItem }
    ) {
      return {
        ...state,
        quickMessagesManagementEditItem
      }
    },

    [resetQuickMessagesManagement]() {
      return initialState
    }
  },
  initialState
)
